import { render, staticRenderFns } from "./PopoverTrigger.vue?vue&type=template&id=587842ce"
import script from "./PopoverTrigger.vue?vue&type=script&lang=js"
export * from "./PopoverTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports